import { ofetch } from 'ofetch'

let invalidateSession: (() => void) | null = null

export function setInvalidateSessionHandler(fn: () => void): void {
  invalidateSession = fn
}

function isPublicEndpoint(path: string): boolean {
  const publicPaths = [
    '/api/plans',
    '/api/auth/providers',
    '/api/auth/check',
    '/api/health',
    '/api/auth/password/forgot',
    '/api/auth/signup',
    '/api/auth/login',
  ]
  if (publicPaths.includes(path)) return true
  if (path.startsWith('/api/auth/oauth/')) return true
  return false
}

const _api = ofetch.create({
  credentials: 'same-origin',
  // ponytail: ofetch gives us the request path in context.request,
  // so each concurrent call classifies its own 401 — no shared mutable state.
  onResponseError({ request, response }) {
    if (response?.status === 401) {
      const path = typeof request === 'string' ? request : ''
      if (!isPublicEndpoint(path) && path.startsWith('/api/')) {
        invalidateSession?.()
      }
    }
  },
})

export function api<T>(
  path: string,
  opts: Record<string, unknown> = {}
): Promise<T> {
  const method = (opts.method as string | undefined)?.toUpperCase?.() || 'GET'
  const isMutation = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)

  return _api<T>(path, {
    retry: isMutation ? false : undefined,
    ...opts,
  })
}
